import React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import SubmitInfo from './SubmitInfo';
import { DOWNLOAD_LINK } from '../../constant';
import SignupWrapper from './SignupWrapper';
import { useContextDispatch, useContextState } from '../context';
import { useAffise } from '../../src/utils/affise';
import { useSessionStorage } from '../../src/hooks/useSessionStorage';

interface FormProps {
  inputId: string;
  btnId: string;
  onChange?: () => void;
  onSubmit?: () => void;
}

const Form: React.FC<FormProps> = ({ inputId, btnId, onChange, onSubmit }) => {
  const { t } = useTranslation();
  const { authorized } = useContextState();

  return (
    <div className="download-now">
      <h2>{t('downloadForm_header')}</h2>
      <form className="inputs">
        <div className="row">
          {/*{!authorized && (*/}
          {/*  <div className="input">*/}
          {/*    <input*/}
          {/*      type="email"*/}
          {/*      placeholder={t('downloadForm_input')}*/}
          {/*      onChange={onChange}*/}
          {/*      id={inputId}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*)}*/}
          <button id={btnId} type="button" className="btn btn-orange" onClick={onSubmit}>
            <span>{t('downloadForm_button')}</span>
          </button>
        </div>
        <SubmitInfo key1="submitInfo_part1" key2="submitInfo_part2" />
      </form>
    </div>
  );
};

const DownloadForm = ({ inputId, btnId }) => {
  const { set } = useSessionStorage();
  const { t } = useTranslation();
  const router = useRouter();
  const { sendAffiseEvent } = useAffise();

  return (
    <SignupWrapper
      notification={{
        text: t('notification_error_email'),
        color: 'red',
      }}
      isAuthRedundant={true}
      sideeffect={() => {
        sendAffiseEvent('Registration');
        window.open('/terminal/download/TigerTradeSetup.exe', '_blank');
        router.push('/terminal/how-to-setup');
        set('downloadNotification', true);
      }}
    >
      <Form inputId={inputId} btnId={btnId} />
    </SignupWrapper>
  );
};

export default DownloadForm;
